import { Transaction, isCefiInfoTx } from "@cede/types";

export function getCefiSide(tx: Transaction) {
  if (isCefiInfoTx(tx.from)) return tx.from;
  if (isCefiInfoTx(tx.to)) return tx.to;
  // Cannot happen if that function is called in the fronted (and nothing is broken in between)
  throw new Error("Transaction does not have a cefi side");
}
